import '.f5{font-size:1.125rem;}.ssr-plugin'
import '.e9{line-height:1.75rem;}.ssr-plugin'
import '.ep{text-decoration:none;}.ssr-plugin'
import '.fw{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="f5 e9"
    >
      {translations.privacySubtitle}{' '}
      <a className="ep fw"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="ep fw"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
